import AzureSearch from '../utils/azure-search';
import { AUTH_TOKEN } from './vue-apollo';
import appConfig from "./config";
import { acquireTokenSilent } from '@/auth/vue-msal/service';

const searchClient = AzureSearch(
  {
    url: appConfig.VUE_APP_SEARCHURL,
    version: "2023-10-01-Preview",
  },
  () => {
    return acquireTokenSilent().then(() => {
      return localStorage.getItem(AUTH_TOKEN);
    })
  }
);

export default searchClient;